import { useRecoilState, useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { pathsState, reportSearchTypeState, reportViewState, selectedPathIdState } from '../../../storage/reports';
import { FloatingCardContent } from '../../layout/cards/FloatingCardContent';
import { FloatingCardsLayout } from '../../layout/FloatingCardsLayout';
import PathInfo from '../../reports/pathsReport/PathInfo';
import { PathList } from '../../reports/pathsReport/PathList';
import { PathListByGroup } from '../../reports/pathsReport/PathLisyByGroup';
import ReportsSharedWrapper from './ReportsSharedWrapper';

function PathsReportsPage() {
  const { theme } = useStyles();
  const reportView = useRecoilValue(reportViewState);
  const reportSearchType = useRecoilValue(reportSearchTypeState);
  const hasPaths = !!useRecoilState(pathsState).length;
  const isGroupReportView = reportSearchType === 1 && reportView === 0;
  const selectedPathId = useRecoilValue(selectedPathIdState);

  return (
    <>
      <FloatingCardsLayout
        content={
          <FloatingCardContent
            flexible
            gap={theme.sizing.scale600}
          >
            <ReportsSharedWrapper>
              {!isGroupReportView && <PathList />}
              {isGroupReportView && <PathListByGroup />}
            </ReportsSharedWrapper>
          </FloatingCardContent>
        }
        contentSize={isGroupReportView && hasPaths ? 650 : 550}
      />
      {selectedPathId && <PathInfo />}
    </>
  );
}

export default PathsReportsPage;
